import { AxiosResponse } from "axios";
import config from "../../../../config/config";
import ApiClient from "../../ApiClient";
import { IMappingWork, IMappingWorkAddRequest, IMappingWorkUpdateRequest } from "./types";
import fileDownload from "js-file-download";

const workApi = new ApiClient("/Work", config.api.baseUrl);

/**
 * Returns a list of all work.
 * @param token
 */
export const getWorkCatalogue = (token: string): Promise<IMappingWork[]> => {
    ApiClient.setAuthorizationToken(token);

    return workApi
        .get("/list", {
            clearCacheEntry: true,
        })
        .then((response: AxiosResponse<IMappingWork[]>) => {
            return Promise.resolve(response.data);
        });
};

/**
 * Create work into catalogue and return created entity.
 * @param token
 * @param data
 */
export const addWorkCatalogue = (token: string, data: IMappingWorkAddRequest): Promise<IMappingWork> => {
    ApiClient.setAuthorizationToken(token);

    return workApi.post("/add", data).then((response: AxiosResponse<IMappingWork>) => {
        return Promise.resolve(response.data);
    });
};

/**
 * Update work in catalogue and return updated entity.
 * @param token
 * @param workID
 * @param data
 */
export const updateWorkCatalogue = (
    token: string,
    workID: number,
    data: IMappingWorkUpdateRequest
): Promise<IMappingWork> => {
    ApiClient.setAuthorizationToken(token);

    return workApi.post(`/${workID}/update`, data).then((response: AxiosResponse<IMappingWork>) => {
        return Promise.resolve(response.data);
    });
};

/**
 * Deletes work from catalogue.
 * @param token
 * @param workID
 */
export const deleteWorkCatalogue = (token: string, workID: number): Promise<boolean> => {
    ApiClient.setAuthorizationToken(token);

    return workApi.get(`/${workID}/delete`).then((response: AxiosResponse<boolean>) => {
        return Promise.resolve(response.status === 204);
    });
};

/**
 * Export work, file is downloaded
 * @param token
 */
export const exportWork = (
    token: string
): Promise<void> => {
    ApiClient.setAuthorizationToken(token);

    return workApi
        .get(`/export`, {
            responseType: "blob"
        })
        .then((response) => {
            // Promise.resolve(response.data)
            fileDownload(response.data, "work.xlsx");
            return;
        });
};

/**
 * Import work, file is uploaded
 * @param token
 * @param data
 */
export const importWork = (
    token: string,
    data: FormData
): Promise<void> => {
    ApiClient.setAuthorizationToken(token);

    return workApi
        .post(`/import`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {
            return Promise.resolve(response.data)
        })
        .catch((response) => {
            return Promise.reject(response.data)
        });
};